export const Labels = {
    sendInvite:'Send Invite',
    sendingInvitation: 'Sending Invitation'
}

export const Messages = {
    InvitationPrevioslySent:'Invitation previously sent on ',
    InvitationSent:'Invitation email successfully sent to ',
    EmailMissing:'Unable to send invitation as there is no email address associated with this member'
}


// WEBPACK FOOTER //
// ./src/containers/newuser/constants.js